<script lang="ts" setup>
import { computed } from 'vue';
import type { CustomerMgmtTypes } from '@ilteducation/customer-mgmt';
import SidePanelSection from '../SidePanel/SidePanelSection.vue';
import useModal, { modals } from '../../composables/useModal';
import { useLocale } from '../../composables/useLocale';
import { useDeleteUserAssociation } from '../../composables/useDeleteUserAssociation';

const { t } = useLocale();

const props = defineProps<{
  user: CustomerMgmtTypes.GetUserResponse;
}>();

const { open: openDeleteUserModal } = useModal(modals.DELETE_USER);

const user = computed(() => props.user);
const { isUserDeletable } = useDeleteUserAssociation(user);
</script>

<template>
  <SidePanelSection>
    <v-row class="justify-end" no-gutters>
      <v-col cols="auto">
        <v-btn color="error" prepend-icon="mdi-trash-can" :disabled="!isUserDeletable" @click="openDeleteUserModal()">
          {{ t('lcp.delete_user') }}
        </v-btn>
      </v-col>
    </v-row>
  </SidePanelSection>
</template>

<style scoped lang="scss"></style>
